export default __webpack_public_path__ + "static/media/PeripartumMainNav.43cdf2b6.jpg";